export { default } from './PostFeaturedImage';
export * from './PostFeaturedImage.types';
